import { IntlContext } from '@utils/useIntl';
import { useContext } from 'react';

const Footer = () => {
  const { translate } = useContext(IntlContext);

  const now = new Date();

  return (
    <footer className="py-8 tablet:py-12 px-4 tablet:px-8 bg-darker border-t border-dark">
      <div className="tablet:w-1/2 tablet:max-w-[300px] mx-auto text-center text-xs text-gray">
        <p>
          © {now.getFullYear()}, Marc Malignan. {translate('footer.copyright')}
        </p>
        {/* <p className="mt-4">{translate('footer.madeBy')}</p> */}
        <p className="mt-4 text-[10px] italic">{translate('footer.usage')}</p>
      </div>
    </footer>
  );
};

export default Footer;
